// @flow
import type {
  RecommendationOperator,
} from '../types'

// Constants
import { MODEL } from 'hfty-model-recommendations'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: RecommendationOperator = composeOperator({
  model: MODEL,
})

export default operator
